/**
 * File: useSectionMenuPageController.ts
 * Path: apps/admin/src/features/menu/hooks/useSectionMenuPageController.ts
 * Description: Finds the section (CRM, Accounting, CMS) whose own page is open, among the menu items this role may see.
 */

import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SIDEBAR_ITEMS, visibleNavItems } from "@idk/config";
import { useRole } from "@/modules/auth/hooks/useRoleQueries";

export const useSectionMenuPageController = () => {
  const { pathname } = useLocation();
  const { can } = useRole();
  const group = useMemo(
    () => visibleNavItems(SIDEBAR_ITEMS, can).find((item) => item.hub === pathname),
    [can, pathname],
  );
  return { group, canSeeLeads: can("sales") };
};
